import {BaseConfig} from "../../infrastructure/config/base-config";
import {AppTerms} from "./app-terms";
import {AppRemoteConfig} from "./app-remote-config";
import {singleton} from "../../infrastructure/decorators/singleton";

@singleton
export class AppModuleConfig extends BaseConfig {

  static injectables = [AppTerms, AppRemoteConfig];

  constructor(terms: AppTerms, remoteConfig: AppRemoteConfig) {
    super('appModule', null, terms, remoteConfig);
  }
}
